import { useEffect } from "react";
import { useApp } from "@/contexts/AppContext";
import LandingPage from "./LandingPage";
import SurveyPage from "./SurveyPage";
import HomePage from "./HomePage";
import GuestOnboardingPage from "./GuestOnboardingPage";

const Index = () => {
  const { user, isAuthenticated, hasSurveyed, loading } = useApp();

  const isGuest = user?.isAnonymous === true;
  // Guests go through a lightweight onboarding (gender + interests) once,
  // then enter the app. Reuses `survey_completed` as the persistence flag.
  const guestNeedsOnboarding = isGuest && !hasSurveyed;

  const isScrollablePage = !isAuthenticated ||
    (!isGuest && !hasSurveyed) || guestNeedsOnboarding;

  useEffect(() => {
    if (isScrollablePage) {
      document.body.classList.remove("app-locked");
    } else {
      document.body.classList.add("app-locked");
    }
    return () => {
      document.body.classList.add("app-locked");
    };
  }, [isScrollablePage]);

  if (loading) {
    // Render an empty themed shell while auth resolves — no spinner flash, no
    // black gap. The background matches the rest of the app.
    return <div className="min-h-screen bg-background" />;
  }

  if (!isAuthenticated) return <LandingPage />;
  if (guestNeedsOnboarding) return <GuestOnboardingPage />;
  if (isGuest) return <HomePage />;
  if (!hasSurveyed) return <SurveyPage />;
  return <HomePage />;
};

export default Index;
